<section style="margin-top: 120px;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                            <strong>We can REVIEW and REVISE your existing written safety program</strong>.
                        </h3>

                        <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="200">
                            If your company already has a written safety program that works well, SFI Safety can review it to 
                            determine whether it aligns with current OSHA requirements, industry standards,
                            and the needs of your operation.
                        </p>
                        <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="300">
                            Once the review is complete, we will provide recommendations to strengthen weak areas, 
                            improve usability, and better address the hazards your employees and subcontractors face.
                             In many cases, updating a proven program is more effective 
                            than starting over. Our safety consultants will help you determine the best approach for your organization.

                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                            <li><span class="mediumFontSize"><strong>An effective safety program should include these 
                                core elements:
                                    </strong></span></li>
                            <ul>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Management Leadership</li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Worker Participation</li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Hazard Identification and
                                    Assessment</li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Hazard Prevention and Control
                                </li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Education and training</li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Program Evaluation and
                                    Implementation
                                </li>
                                <li><i class="fa fa-circle fontRed facirclesize"></i> Communication and Coordination
                                </li>
                            </ul>
                            <p></p>
                            <p class="theme_color fontSize">Our goal is to help you move Beyond Compliance by creating a program that is practical, current, and easier to implement in the field.</p>
                            <p class="theme_color fontSize">
                                Contact SFI Safety to review or update your written safety program at <a href="customerservice@sfisafety.com">customerservice@sfisafety.com</a> or call:
                            </p>
                            <p class="theme_color fontSize">
                                OSHA Safety Programs in Carolinas  - call 980-217-6100
                            </p>
                            <p class="theme_color fontSize">
                                OSHA Safety Programs in Colorado - call 303-649-1304
                            </p>
                            <p class="theme_color fontSize">
                                OSHA Safety Programs in Arizona - call 602-325-1950
                            </p>
                            <p class="theme_color fontSize">
                                OSHA Safety Programs in Florida - call 813-867-7200
                            </p>
                            <p class="theme_color fontSize">
                                We also provide <a href="/safetytraining">Safety Training</a> and <a
                                    href="/safetyinspection">Safety Inspections</a>
                            </p>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>